import { Box, keyframes } from "@mui/material";
import PropTypes from "prop-types";

const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

const DotPulseLoading = ({
  size = 12,
  color = "primary.main",
  count = 3,
  height = 200,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: height,
        gap: 1.5,
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <Box
          key={index}
          sx={{
            width: size,
            height: size,
            backgroundColor: color,
            borderRadius: "50%",
            animation: `${bounce} 1.5s infinite ease-in-out`,
            animationDelay: `${index * 0.2}s`,
          }}
        />
      ))}
    </Box>
  );
};

DotPulseLoading.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  count: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default DotPulseLoading;
